import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "../../../../form/src/common/components/system-control/pc/index.vue";
import mobile from "../../../../form/src/common/components/system-control/mobile/index.vue";
const info = {
    title: "单据号",
    title_i18n: "{\"zh\": \"单据号\", \"en\": \"SequenceNo\"}",
    type: "sequence-number",
    icon: "h-icon-all-barcode-o",
    dataItemType: DataItemType.ShortText,
    formControllerType: FormControlType.SequenceNo,
    group: "系统控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
